import i18n from '@/i18n/locale';

export default [
  // 首页
  {
    path: '/address',
    name: 'address',
    meta: {
      title: i18n.t('地址'),
      hideHeader: true,
      showFooter: true,
      hideQuickEntrance: true,
      signOutNoBackFeed: true,
      loginWithoutVerification: true, // 是否不需要校验登录
      notCheckPl: true // 不校验pl
    },
    component: () =>
      import(
        /* webpackChunkName: "address" */
        '@/views/Address/index'
      ),
  },
];
